import { Link } from 'react-router-dom';

export function HeaderLogo() {
  return (
    <div className="flex items-center gap-2 lg:gap-5">
      <Link to="/" className="shrink-0">
        <h3 className="text-accent-foreground text-base">Aferições Admin</h3>
      </Link>
    </div>
  );
}

